import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ResponseResult } from '@app/auth/model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private route: string = "admin";
  private controller: string = "dashboard";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  get(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/get`);
  }

  classRunning(date: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/classRunning/${date}`);
  }

  contentSeriesAndEpisodes(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/contentSeriesAndEpisodes`);
  }
}